import './App.css'
import Navigation from './components/Navigation'
import Hero from './components/Hero'
import Services from './components/Services'
import Portfolio from './components/Portfolio'
import LocalSEO from './components/LocalSEO'
import Process from './components/Process'
import Pricing from './components/Pricing'
import FAQ from './components/FAQ'
import About from './components/About'
import Contact from './components/Contact'
import Footer from './components/Footer'
import BackToTop from './components/BackToTop'

function App() {
  return (
    <div className="min-h-screen bg-cream text-ink">
      <div className="grain-overlay" aria-hidden="true" />
      <Navigation />
      <main>
        <Hero />
        <Services />
        <Portfolio />
        <LocalSEO />
        <Process />
        <Pricing />
        <FAQ />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  )
}

export default App
